var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSquareArrow01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 29"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 27.538,
  x: 0.5,
  y: 0.73,
  stroke: "#E2E2E2",
  rx: 5.5
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon_square_arrow_01_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.667 12.425 14 15.758l3.333-3.333.825.825L14 17.408 9.842 13.25z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_square_arrow_01_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 9.5v10H9v-10z"
})))));
export default SvgIconSquareArrow01;